import { BTCNFT } from '../interfaces/common'

const ORDINALS_API_URL = 'https://api.hiro.so/ordinals/v1/inscriptions'

interface OrdinalsResponse {
  limit: number
  offset: number
  total: number
  results: OrdinalApiType[]
}

interface OrdinalApiType {
  id: string
  tx_id: string
  metadata?: Record<string, string>
  number: number
  address: string
  content_type?: string
  content_length: number
  value: string
  sat_ordinal: string
  sat_rarity: string
  timestamp: number
  genesis_timestamp: number
  offset: string
}

class OrdinalsClient {
  static mapApiToBTCNFT(ordinal: OrdinalApiType): BTCNFT {
    return {
      id: ordinal.id,
      txId: ordinal.tx_id,
      metadata: ordinal.metadata,
      number: ordinal.number,
      address: ordinal.address,
      contentType: ordinal.content_type,
      contentLength: ordinal.content_length,
      value: ordinal.value,
      satOrdinal: ordinal.sat_ordinal,
      satRarity: ordinal.sat_rarity,
      timestamp: ordinal.timestamp,
      genesisTimestamp: ordinal.genesis_timestamp,
      standard: 'ordinal',
      url: `https://ordinals.com/content/${ordinal.id}`,
      collection: `ordinal-${ordinal.number}`,
      mintIndex: parseInt(ordinal.offset),
    }
  }

  async getOrdinals(address: string): Promise<BTCNFT[]> {
    const response = await fetch(
      `${ORDINALS_API_URL}?address=${address}&limit=60` // TODO: user might have more than 60 ordinals
    )

    if (response.ok) {
      const data: OrdinalsResponse = await response.json()
      const ordinalsWithUrl: BTCNFT[] = data.results.map(OrdinalsClient.mapApiToBTCNFT)

      return ordinalsWithUrl
    } else {
      throw response.text()
    }
  }
}

export default OrdinalsClient
